import { render, staticRenderFns } from "./rolesCreate.vue?vue&type=template&id=78c808b7"
import script from "./rolesCreate.vue?vue&type=script&lang=js"
export * from "./rolesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports